import React from 'react'

import { Button, H2, ModalBase } from 'src/common'
import { isMobile } from 'src/helpers'

export const SessionError = () => {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <ModalBase
      isOpen={true}
      hiddenClose={true}
      classModal={`modal-base ${isMobile ? 'mobile' : 'desktop'} unserviceable-modal session-error-modal`}
    >
      <div className="unserviceable-wrapper">
        <H2 className="title mt-0px-auto">Uh oh!</H2>
        <div className="fz-15rem mb-20rem text-content">We hit a snag — refresh to restart</div>
        <div className="button-wrapper">
          <Button className="button button-primary mlr-10rem mb-10rem btn-refresh" onClick={handleRefresh}>
            Refresh
          </Button>
        </div>
      </div>
    </ModalBase>
  )
}
